<!-- eslint-disable vue/valid-v-model -->
<template lang="html">
  <d-card class="card-small mb-4">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Variações do Produto</h6>
        </d-col>
      </d-row>
    </d-card-header>
    <d-list-group flush>
      <d-list-group-item class="p-3" v-for="(variation, index) in model.list" :key="index">
        <d-row class="align-items-center">
          <d-col>
            <d-row>
              <d-col cols="8">
                <label for="feCode">Opções</label>
                <ul class="options">
                  <li v-for="(option, index) in variation.variation_type_options" :key="index" class="label-pill">
                    <span class="label">{{ option.name }}</span>
                  </li>
                </ul>
              </d-col>
              <d-col cols="2">
                <label>Produto disponível</label>
                <d-checkbox
                  toggle
                  :value="1"
                  :unchecked-value="0"
                  :checked="`${variation.available}`"
                  @change="toggleItem(variation, 'available')"
                  class="custom-toggle-sm"
                >Sim</d-checkbox>
              </d-col>
              <d-col cols="2">
                <label>Incluir na apresentação</label>
                <d-checkbox
                  toggle
                  :value="1"
                  :unchecked-value="0"
                  :checked="`${variation.show_presentation}`"
                  @change="toggleItem(variation)"
                  class="custom-toggle-sm"
                >Sim</d-checkbox>
              </d-col>
            </d-row>
            <d-form-row>
              <!-- Code -->
              <d-col md="2" class="form-group">
                <label for="feCode">Código de Interno</label>
                <d-form-input type="text" v-model="variation.code" id="feCode" placeholder="Código Interno" readonly />
              </d-col>
              <d-col>
                <label for="feCode">Nome</label>
                <d-form-input type="text" v-model="variation.name" id="feCode" placeholder="Nome" />
              </d-col>
              <!-- Barcode -->
              <d-col md="2" class="form-group">
                <label for="feBarcode">Código de barras</label>
                <d-form-input type="text" v-model="variation.barcode" id="feBarcode" placeholder="Código de barras" />
              </d-col>

            </d-form-row>
            <d-form-row>

              <!-- Price -->
              <d-col md="3" class="form-group">
                <label for="fePrice">Preço</label>
                <d-input-group prepend="R$">
                  <input-currency
                    model-index="price"
                    placeholder="Total"
                    :model="variation"
                  ></input-currency>
                </d-input-group>
              </d-col>

              <!-- Warranty -->
              <d-col md="3" class="form-group">
                <label for="feWarranty">Garantia</label>
                <InputWarranty :warranty.sync="variation.warranty_period" :warrantyTypeId.sync="variation.warranty_type"/>
              </d-col>

            </d-form-row>

            <d-form-row>
              <d-col md="9" class="form-group">
                <!-- Contract clause -->
                <label for="feDescription">Clausula no contrato</label>
                <editor :ref="'contract_'+variation.id" id="contract" :model.sync="variation.contract_clause" />
              </d-col>
              <d-col md="3" class="form-group">
                <d-form-row>
                  <!-- Imagem -->
                  <d-col md="12" class="form-group">
                    <label for="feImage">Imagem da apresentação</label>
                    <upload-image :model.sync="model.list[index]" ></upload-image>
                  </d-col>
                </d-form-row>
              </d-col>
            </d-form-row>
          </d-col>
          <d-col cols="auto" class="pl-0">
            <d-button class="btn-block btn-success" type="button" @click.stop="saveVariation(variation)">Salvar</d-button>
            <d-button class="btn-block btn-danger" type="button" v-if="model.total_items > 1" @click.stop="deleteVariation(variation)">Deletar</d-button>
          </d-col>
        </d-row>
        <d-row v-if="model.list.length == 0">
          <d-col class="no-content p-4">Ainda não foram cadastrados nenhum tipo de variação.</d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
    <pagination class="pb-3" :total-items="model.total_items" :pagination.sync="pagination" event-name="pagination:productVariation"></pagination>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import UploadImage from '_shared/UploadImage.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import InputCurrency from '_shared/InputCurrency.vue';
import InputWarranty from '_shared/InputWarranty.vue';
import ProductService from '_services/rest/modules/product';
import { _RELOAD_VARIATION_, _DELETE_PRODUCT_VARIATION_, MODEL_VARIATION } from './ProductModel';

export default {
  name: 'product-variations',
  components: {
    Editor,
    Pagination,
    UploadImage,
    Autocomplete,
    InputCurrency,
    InputWarranty,
  },
  computed: {
  },
  data() {
    return {
      model: [{ ...MODEL_VARIATION }],
      search: '',
      variationSelected: null,
      pagination: {
        search: '',
        id: this.$store.state.product.product.id,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    deleteVariation(option) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_PRODUCT_VARIATION_, option);
    },
    getVariations() {
      ProductService.getVariationsList(this.pagination)
        .then(response => {
          this.model = response;
        });
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.search = name;
      }, 500);
    },
    saveVariation(variation) {
      if (variation.image.url && !variation.image.id) {
        return ProductService.uploadFile(variation.image)
          .then(response => {
            variation.image = response;
            variation.image_id = response.id;
            this.updateVariation(variation);
          });
      }
      return this.updateVariation(variation);
    },
    toggleItem(item, field = 'show_presentation') {
      item[field] = (item[field]) ? 0 : 1;
    },
    updateVariation(variation) {
      ProductService.updateVariation(variation).then(() => {
        this.activeAlert({ message: 'Variação atualizada', theme: 'success' });
      });
    },
  },
  mounted() {
    Events.$on(_RELOAD_VARIATION_, () => {
      this.getVariations();
    });
    Events.$on('pagination:productVariation', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getVariations();
    });
    this.getVariations();
  },
};
</script>

<style lang="scss" scoped>

.align-center {
  vertical-align: middle;
}

.list-group {
  &-item {
    background-color: rgba(0, 0, 0, 0.05);
    &:nth-of-type(odd) {
      background-color: #fff;
    }
  }
}

.options {
  list-style: none;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  margin-bottom: 0;
  padding-left: 0;
  li {
    padding: 5px;
    margin-right: 5px;
  }
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
